module.exports = __webpack_public_path__ + "img/header.31a269ca.png";